export const environment = {
  production: true,
  apiUrl: "https://api.prod.hydrologywellness.com/api/"
};
